import React, { useEffect, useState } from "react";
import { Button, Collapse, Menu, MenuItem, Popover, Tooltip } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import InboxRoundedIcon from "@mui/icons-material/InboxRounded";
import DirectionsRunRoundedIcon from "@mui/icons-material/DirectionsRunRounded";
import EventNoteRoundedIcon from "@mui/icons-material/EventNoteRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import LayersRoundedIcon from "@mui/icons-material/LayersRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import FlagRoundedIcon from "@mui/icons-material/FlagRounded";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import DriveFileMoveRoundedIcon from "@mui/icons-material/DriveFileMoveRounded";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import BacklogTable from "../BacklogTable";
import API_BASE_URL from "../config/appConfig";
import { useToast } from "../Toast";
import axios from "axios";
import SprintStartModal from "./SprintStartModal";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { getSprintsList, getBacklogIssues } from "../../common/Redux/Reducer";
import CompletConfirmationModal from "../Modal/DeleteConfirmationModal";
import SelectMenuTextField from "../SelectMenuTextField";
import * as XLSX from "xlsx";

/* the three statuses the card header summarises, in board order */
const COUNT_PILLS = [
  ["To Do", "slate"],
  ["In Progress", "blue"],
  ["Done", "green"],
];

const ProjectIssues = ({
  openGallery,
  name,
  sprint = null,
  issues = [],
  index = null,
  sprintData = {},
  handleIssueClick = () => {},
  handleSprintIssueClick = () => {},
  searchTerm,
  AllsprintDetails = [],
  IssuecountObj = {},
  isActiveSprintExist = true,
  setIsActiveSprintExist = () => {},
  activeSprint,
  selectedIssueType = "",
  selectPriorityType = "",
  selectedEpic = "",
}) => {
  const [issuesCount, setIssuesCount] = useState(issues?.length || 0);
  const [openModal, setOpenModal] = useState(false);
  const [sprintId, setSprinId] = useState(null);
  const [isSprintEditable, setIsSprintEditable] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [creatingSprint, setCreatingSprint] = useState(false);
  const [moving, setMoving] = useState(false);
  const dispatch = useDispatch();
  const toast = useToast();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectSprintanchorEl, setSelectSprintanchorEl] = useState(null);

  const isBacklog = name === "backlog";
  const isLive = Boolean(sprintData?.active);
  const filteredSprintDetails = AllsprintDetails.filter((each) => each._id !== sprintData._id);
  const options = isBacklog ? filteredSprintDetails : [...filteredSprintDetails, { _id: "123", name: "Move to Backlog", value: "123" }];
  const hasIssues = issues && issues.length > 0;
  const [issuesSelected, setIssuesSelected] = useState([]);
  const openMenu = Boolean(anchorEl) && !isBacklog;
  const openSelectSprint = Boolean(selectSprintanchorEl);

  const filterAssigneesArray = useSelector((state) => state.ProjamAppSlice.assignees);
  const { Projects } = useSelector((state) => state.ProjamAppSlice);
  let backlogId = Projects?.selectedProject?.selectedProjectBackLogId;

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [modalConfig, setModalConfig] = useState({});

  useEffect(() => {
    setIssuesCount(issues?.length || 0);
  }, [issues, isActiveSprintExist, AllsprintDetails]);

  const handlePopOverClose = () => setAnchorEl(null);

  const handelMoveSprintPopOverClick = (event) => {
    // the move target is chosen fresh each time, never left over from "Start sprint"
    setSprinId(null);
    setSelectSprintanchorEl(event.currentTarget);
  };
  const handelMoveSprintPopOverClose = () => setSelectSprintanchorEl(null);

  const CreateNewSprint = async () => {
    if (creatingSprint) return;
    setCreatingSprint(true);
    try {
      await axios.post(`${API_BASE_URL}/sprints/createSprint`, { backlog: backlogId });
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
      toast.success("Sprint created");
    } catch (error) {
      console.log(error);
      toast.error("Could not create a sprint");
    } finally {
      setCreatingSprint(false);
    }
  };

  const handleCompleteSprint = async (completeSprintId) => {
    try {
      await axios.put(`${API_BASE_URL}/sprints/updateSprint/${completeSprintId}`, {
        active: false,
        completed: true,
      });
      setIsActiveSprintExist(false);
      toast.success("Sprint completed");
    } catch (error) {
      console.log(error);
      toast.error("Could not complete the sprint");
    }
    setOpenDeleteDialog(false);
    dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
  };

  const openConfirmModal = (config) => {
    setModalConfig(config);
    setOpenDeleteDialog(true);
  };

  const handleConfirm = () => {
    if (modalConfig.action) {
      modalConfig.action(modalConfig.sprintId);
    }
    setOpenDeleteDialog(false);
  };

  const handleDeleteSprint = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/sprints/deleteSprint/${id}`);
      await dispatch(getSprintsList({ backlogId: backlogId }));
      toast.success("Sprint deleted");
    } catch (error) {
      console.log(error);
      toast.error("Could not delete the sprint");
    } finally {
      handlePopOverClose();
    }
  };

  const handleStartSprint = async (values, startSprintId) => {
    try {
      await axios.put(`${API_BASE_URL}/sprints/updateSprint/${startSprintId}`, {
        active: true,
        completed: false,
      });
      await dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
      setIsActiveSprintExist(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handelMoveIssuesToSprint = async () => {
    if (!sprintId || moving) return;
    const count = issuesSelected.length;
    setMoving(true);
    try {
      await axios.put(`${API_BASE_URL}/issues/moveto/sprint/${sprintId}`, { selectedIssues: issuesSelected });
      setIsActiveSprintExist(true);
      setIssuesSelected([]);
      toast.success(`Moved ${count} ${count === 1 ? "issue" : "issues"}`);
    } catch (error) {
      console.log(error);
      toast.error("Could not move the issues");
    } finally {
      setMoving(false);
      handelMoveSprintPopOverClose();
      dispatch(getSprintsList({ backlogId: backlogId, filterAssigneesArray: filterAssigneesArray }));
      dispatch(getBacklogIssues(backlogId));
    }
  };

  const handleDownload = async (sprintName) => {
    try {
      let selectSprintIssues = await axios.post(`${API_BASE_URL}/sprints/download`, { sprintname: sprintName });
      const sprintIssues = selectSprintIssues?.data?.issues || [];
      let reqData = sprintIssues.map((issue) => {
        let { assignee, name: cardId, summary, description, storyPointEstimate, priority, label, status } = issue;
        let assignedTo = assignee?.[0]?.employeeName || "";
        let DescriptionDiv = document.createElement("div");
        DescriptionDiv.innerHTML = description ? description : "";
        let puredescription = DescriptionDiv?.textContent || DescriptionDiv?.innerText || "";
        return {
          "Card ID": cardId,
          Title: summary,
          Description: puredescription ? puredescription : "",
          "Story Points": storyPointEstimate,
          Priority: priority,
          Label: label,
          "Assigned to": assignedTo,
          Status: status,
        };
      });
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(reqData);
      XLSX.utils.book_append_sheet(wb, ws, String(sprintName || "Sprint").slice(0, 31));
      XLSX.writeFile(wb, `${sprintName}.xlsx`);
      toast.success(`${sprintName} downloaded`);
    } catch (error) {
      console.log(error);
      toast.error("Could not download the sprint");
    }
  };

  const isKanban = sprintData?.boardType === "kanban";
  const dateRange = isKanban && sprintData?.releaseDate
    ? `Release ${moment(new Date(sprintData.releaseDate)).format("DD MMM YYYY")}`
    : sprintData?.startDate && sprintData?.endDate
      ? `${moment(new Date(sprintData.startDate)).format("DD MMM")} – ${moment(new Date(sprintData.endDate)).format("DD MMM")}`
      : null;

  const TileIcon = isBacklog ? InboxRoundedIcon : isLive ? DirectionsRunRoundedIcon : EventNoteRoundedIcon;
  const tileTone = isBacklog ? "slate" : isLive ? "green" : "blue";

  return (
    <section
      className={`bl-card ${isLive ? "is-live" : ""} ${isBacklog ? "is-backlog" : ""}`}
      style={{ "--d": `${Math.min(Number(index) || 0, 6) * 50}ms` }}
    >
      <header className="bl-card__head">
        <div className="bl-card__identity">
          <button
            type="button"
            className={`bl-chevron ${expanded ? "is-open" : ""}`}
            onClick={() => setExpanded((value) => !value)}
            aria-expanded={expanded}
            aria-label={`${expanded ? "Collapse" : "Expand"} ${isBacklog ? "backlog" : name}`}
          >
            <ExpandMoreRoundedIcon />
          </button>
          <span className={`bl-card__tile pj-tone--${tileTone}`} aria-hidden="true">
            <TileIcon />
          </span>
          <div className="bl-card__heading">
            <div className="bl-card__title-row">
              <h2 className="bl-card__title">{isBacklog ? "Backlog" : name}</h2>
              {isKanban ? <span className="bl-kanban-tag">Kanban</span> : null}
              {isLive ? (
                <span className="bl-live">
                  <span className="bl-live-dot" />
                  Active
                </span>
              ) : null}
              {!isBacklog ? (
                <Tooltip title={isKanban ? "Edit Kanban board" : "Edit sprint"}>
                  <button
                    type="button"
                    className="bl-edit"
                    aria-label={`Edit ${name}`}
                    onClick={() => {
                      setOpenModal(true);
                      setIsSprintEditable(true);
                    }}
                  >
                    <EditRoundedIcon />
                  </button>
                </Tooltip>
              ) : null}
            </div>
            <div className="bl-card__meta">
              {dateRange ? (
                <span className="bl-meta-chip bl-meta-chip--sm">
                  <CalendarMonthRoundedIcon />
                  {dateRange}
                </span>
              ) : null}
              <span className="bl-meta-chip bl-meta-chip--sm">
                <LayersRoundedIcon />
                {issuesCount} {issuesCount === 1 ? "issue" : "issues"}
              </span>
            </div>
          </div>
        </div>

        <div className="bl-card__actions">
          {!isBacklog ? (
            <div className="bl-counts d-none d-lg-flex">
              {COUNT_PILLS.map(([status, tone]) =>
                IssuecountObj?.[status] !== undefined ? (
                  <Tooltip key={status} title={status}>
                    <span className={`bl-count-pill pj-tone--${tone}`}>
                      <span className="bl-count-pill__dot" />
                      {IssuecountObj[status]}
                    </span>
                  </Tooltip>
                ) : null
              )}
            </div>
          ) : null}

          {issuesSelected.length > 0 ? (
            <Button className="bl-btn bl-btn--ghost is-pop" startIcon={<DriveFileMoveRoundedIcon />} onClick={handelMoveSprintPopOverClick} disableRipple>
              Move {issuesSelected.length}
            </Button>
          ) : null}

          {isBacklog ? (
            <Button className="bl-btn bl-btn--ghost" startIcon={<AddRoundedIcon />} onClick={CreateNewSprint} disabled={creatingSprint} disableRipple>
              {creatingSprint ? "Creating…" : "Create sprint"}
            </Button>
          ) : isLive ? (
            <Button
              className="bl-btn bl-btn--primary"
              startIcon={<FlagRoundedIcon />}
              disableRipple
              onClick={() =>
                openConfirmModal({
                  title: `Are you sure you want to complete this ${sprintData?.name} sprint ?`,
                  description: "Are you sure you want to proceed?",
                  btnText: "Yes",
                  action: handleCompleteSprint,
                  sprintId: sprintData?._id,
                  isCompleteConfirm: true,
                })
              }
            >
              Complete sprint
            </Button>
          ) : (
            <Button
              className="bl-btn bl-btn--accent"
              startIcon={<RocketLaunchRoundedIcon />}
              disabled={!hasIssues || isActiveSprintExist}
              disableRipple
              onClick={() => {
                setOpenModal(true);
                setSprinId(sprintData?._id);
              }}
            >
              Start sprint
            </Button>
          )}

          {!isBacklog ? (
            <Tooltip title="More actions">
              <button type="button" className="bl-icon-btn bl-icon-btn--sm d-none d-md-inline-grid" onClick={(event) => setAnchorEl(event.currentTarget)} aria-label={`More actions for ${name}`}>
                <MoreHorizRoundedIcon />
              </button>
            </Tooltip>
          ) : null}
        </div>
      </header>

      <Collapse in={expanded} timeout={280}>
        {openGallery ? (
          <BacklogTable
            data={issues}
            sprint={sprint}
            handleIssueClick={handleIssueClick}
            handleSprintIssueClick={handleSprintIssueClick}
            searchTerm={searchTerm}
            issuesSelected={issuesSelected}
            setIssuesSelected={setIssuesSelected}
            selectedIssueType={selectedIssueType}
            selectPriorityType={selectPriorityType}
            selectedEpic={selectedEpic}
          />
        ) : null}
      </Collapse>

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handlePopOverClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { className: "bl-menu" } }}
      >
        {hasIssues ? (
          <MenuItem
            onClick={() => {
              handlePopOverClose();
              handleDownload(name);
            }}
          >
            <FileDownloadRoundedIcon />
            Download sprint
          </MenuItem>
        ) : null}
        <MenuItem
          className="is-danger"
          onClick={() => {
            handlePopOverClose();
            openConfirmModal({
              title: `Delete ${sprintData?.name}?`,
              description: "The sprint is removed. Are you sure you want to proceed?",
              btnText: "Delete",
              action: handleDeleteSprint,
              sprintId: sprintData?._id,
              isCompleteConfirm: false,
            });
          }}
        >
          <DeleteOutlineRoundedIcon />
          Delete sprint
        </MenuItem>
      </Menu>

      <Popover
        open={openSelectSprint}
        anchorEl={selectSprintanchorEl}
        onClose={handelMoveSprintPopOverClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { className: "bl-popover" } }}
      >
        <div className="bl-move">
          <span className="bl-move__title">
            Move {issuesSelected.length} {issuesSelected.length === 1 ? "issue" : "issues"}
          </span>
          <SelectMenuTextField
            labelText="Select Sprint"
            options={options}
            onChange={(e) => setSprinId(e.target.value)}
            MenuProps={{ PaperProps: { className: "bl-select-menu" } }}
          />
          <div className="bl-move__actions">
            <Button className="bl-btn bl-btn--ghost bl-btn--sm" onClick={handelMoveSprintPopOverClose} disableRipple>
              Cancel
            </Button>
            <Button className="bl-btn bl-btn--primary bl-btn--sm" disabled={!sprintId || moving} onClick={handelMoveIssuesToSprint} disableRipple>
              {moving ? "Moving…" : "Move"}
            </Button>
          </div>
        </div>
      </Popover>

      {openModal ? (
        <SprintStartModal
          setOpenModal={setOpenModal}
          handleStartSprint={() => handleStartSprint(null, sprintId)}
          sprintData={sprintData}
          issuesCount={issuesCount}
          isSprintEditable={isSprintEditable}
          setIsSprintEditable={setIsSprintEditable}
        />
      ) : null}

      <CompletConfirmationModal
        open={openDeleteDialog}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleConfirm}
        title={modalConfig?.title}
        description={modalConfig?.description}
        btnText={modalConfig?.btnText}
        isCompleteConfirm={modalConfig?.isCompleteConfirm}
        activeSprint={activeSprint}
        AllsprintDetails={AllsprintDetails}
        setOpenDeleteDialog={setOpenDeleteDialog}
        sprintId={modalConfig?.sprintId}
        isActiveSprintExist={isActiveSprintExist}
        setIsActiveSprintExist={setIsActiveSprintExist}
      />
    </section>
  );
};

export default ProjectIssues;
